import {
  Box,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Popover,
  Tooltip,
  Typography,
} from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';

export function HelpPopover() {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  return (
    <React.Fragment>
      <Tooltip title={t('sync.availability.help.tooltip')} arrow>
        <IconButton
          aria-describedby={id}
          onClick={handleClick}
          style={{
            backgroundColor: '#419ad1',
          }}
          size="small"
        >
          <QuestionMarkIcon fontSize="small" style={{ color: '#f5f5f5' }} />
        </IconButton>
      </Tooltip>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Box padding={2} maxWidth={400}>
          <Typography variant="body2">
            <b>{t('sync.availability.help.disp.title')}</b>{' '}
            {t('sync.availability.help.disp.desc')}
          </Typography>
          <Typography variant="body2">
            <b>{t('sync.availability.help.pichinchaDisp.title')}</b>{' '}
            {t('sync.availability.help.pichinchaDisp.desc')}
          </Typography>
          <List disablePadding>
            <ListItem>
              <ListItemText>
                <Typography variant="body2">
                  {t('sync.availability.help.pichinchaDisp.logic1')}
                </Typography>
                <Typography variant="body2">
                  {t('sync.availability.help.pichinchaDisp.logic2')}
                </Typography>
              </ListItemText>
            </ListItem>
          </List>
          <Typography variant="body2">
            {t('sync.availability.help.note')}
          </Typography>
        </Box>
      </Popover>
    </React.Fragment>
  );
}
